import { jsx as _jsx } from "react/jsx-runtime";
export const SpinnerStyles = ({ inputClassName, color }) => (_jsx("style", { children: `
           .${inputClassName} circle {
                stroke: ${color}
           }
        ` }, void 0));
//# sourceMappingURL=spinner-styles.js.map